import DeviceManager from '../utils/device-manager';
// @ts-expect-error ScrollMagic has no default export in the typped declaration
import ScrollMagic, { Controller, Scene, ProgressEvent } from 'scrollmagic';

export function initTimelines() : void {
    document.querySelectorAll<HTMLElement>('.section-timeline').forEach($timeline => {
        new Timeline($timeline);
    });
}

/**
 * @property {boolean} initialized True if ScrollMagic is bind to $timeline
 * @property {Controller} controller ScrollMagic Controller
 * @property {Scene} scene ScrollMagic Scene
 * @property {HTMLElement} $timeline Timeline Element
 * @property {NodeList.<HTMLElement>} $timelineItems Timeline items NodeList of Elements
 * @property {HTMLElement} $timelineWrapper Timeline wrapper
 * @property {HTMLElement} $timelineGhostContainer Timeline ghost container
 * @property {HTMLElement} $timelineWrapperGhost Timeline wrapper of ghost container
 */
class Timeline {
    $timeline: HTMLElement;
    initialized: boolean;
    controller: Controller|null = null;
    scene: Scene|null = null;
    $timelineItems: NodeListOf<HTMLElement>|null = null;
    $timelineContainer: HTMLElement|null = null;
    $timelineWrapper: HTMLElement|null = null;
    $timelineGhostContainer: HTMLElement|null = null;
    $timelineWrapperGhost: HTMLElement|null = null;

    constructor($timeline: HTMLElement) {
        this.$timeline = $timeline;
        this.initialized = false;

        DeviceManager.addCallback(attr => {
            if (!this.initialized && DeviceManager.isGreaterThanOrEqual(attr.current, 'lg')) { // Large device
                this.initialize();
            } else if (this.initialized && !DeviceManager.isGreaterThanOrEqual(attr.current, 'lg')) { // Small device
                this.destroy();
            } else if (this.initialized) { // Reinitialize for large device
                this.reInitialize();
            }
        });

        DeviceManager.addWindowCallback(attr => {
            if (!this.initialized && DeviceManager.isGreaterThanOrEqual(attr.current, 'lg')) { // Large device
                this.initialize();
            } else if (this.initialized && !DeviceManager.isGreaterThanOrEqual(attr.current, 'lg')) { // Small device
                this.destroy();
            } else if (this.initialized) { // Reinitialize for large device
                this.reInitialize();
            }
        });
    }

    initialize() : void {
        this.initialized = true;
        this.controller = new ScrollMagic.Controller();
        this.$timelineItems = this.$timeline.querySelectorAll<HTMLElement>('.timeline');
        this.$timelineContainer = this.$timeline.querySelector('.timeline-container') as HTMLElement;
        this.$timelineWrapper = this.$timelineContainer.querySelector('.wrapper-timeline') as HTMLElement;
        this.$timelineWrapper.classList.remove('active');

        this.$timelineGhostContainer = document.createElement('div');
        this.$timelineGhostContainer.classList.add('timeline-ghost-container');

        this.$timelineWrapperGhost = this.$timelineWrapper.cloneNode() as HTMLElement;
        this.$timelineWrapperGhost.classList.add('wrapper-timeline-ghost');
        this.$timelineWrapperGhost.innerHTML = this.$timelineWrapper.innerHTML;
        this.$timelineWrapperGhost.style.width = window.getComputedStyle(this.$timelineWrapper).width;

        this.$timelineGhostContainer.appendChild(this.$timelineWrapperGhost);
        this.$timelineContainer.appendChild(this.$timelineGhostContainer);

        const $stickyBar = document.querySelector<HTMLElement>('.sticky-bar');
        let stickyBarHeight = 0;

        if ($stickyBar) {
            const stickyBarIsVisible = window.getComputedStyle($stickyBar).display !== 'none';

            if ($stickyBar && stickyBarIsVisible) {
                stickyBarHeight = $stickyBar.clientHeight;
            }
        }

        const sceneOffset = (window.innerHeight / 2) - stickyBarHeight;
        const sceneDuration = this.$timelineItems.length * 200;

        const middleTimelineItemsPercent: number[] = [];
        let progessWidthTimelineItemsTotal = 0;
        this.$timelineItems.forEach($item => {
            if (this.$timelineContainer) {
                const pourcentageMiddleItem = ((progessWidthTimelineItemsTotal + ($item.clientWidth / 2)) * 100) / this.$timelineContainer.clientWidth;
                middleTimelineItemsPercent.push(pourcentageMiddleItem);
                progessWidthTimelineItemsTotal = progessWidthTimelineItemsTotal + $item.clientWidth;
            }
        });

        this.scene = new ScrollMagic.Scene({
            duration: sceneDuration,
            offset: sceneOffset,
            triggerElement: this.$timeline,
        })
            .setPin(this.$timeline)
            .addTo(this.controller);

        (this.scene as Scene).on('progress', (e: ProgressEvent) => {
            (this.$timelineGhostContainer as HTMLElement).style.width = (e.progress * 100) + '%';
            (this.$timelineItems as NodeListOf<HTMLElement>).forEach(($item, index) => {
                if (e.progress * 100 >= middleTimelineItemsPercent[index]) {
                    $item.classList.add('active');
                } else {
                    $item.classList.remove('active');
                }
            });
        });
    }

    reInitialize() : void {
        this.destroy();
        this.initialize();
    }

    destroy() : void {
        this.initialized = false;
        this.controller?.destroy(true);
        this.$timelineWrapper?.classList.add('active');
        this.$timelineGhostContainer?.remove();
    }
}
